


























































import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import Vue from 'vue'
import { MetaService } from '@/shared/services/meta-service'
import { Injector } from '@/config/dependency-injection'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { OrganisationResponse, ProjectLiteResponse } from '@/api/generated'
import { backgroundImage, imageUrl } from '@/shared/utils/images'
import { activeUserIsOwner } from '@/shared/utils/user'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import RespondecoToolbarItem from '@/shared/components/toolbar/respondeco-toolbar-item.vue'
import { environmentConfiguration } from '@/config/environments'

@Component({
  name: 'organisation-projects',
  components: { RespondecoToolbarItem, RespondecoToolbar },
})
export default class OrganisationProjects extends Vue implements Hooks {
  public backgroundImage = backgroundImage
  public branding = environmentConfiguration().branding
  public imageUrl = imageUrl

  private metaService: MetaService = Injector.get(MetaService)
  private organisationsModule: OrganisationsModule = Injector.get(OrganisationsModule)

  get allProjects(): ProjectLiteResponse[] {
    return this.organisationsModule.organisationViewModel.projects
  }

  get canAddOrUpdate() {
    return activeUserIsOwner(this.organisation.id)
  }

  get organisation(): OrganisationResponse {
    return this.organisationsModule.organisationViewModel.organisation
  }

  public mounted() {
    this.metaService.updateDocumentTitle('organisation.projects', {
      name: this.organisation.name,
    })

    this.metaService.updateSeo({
      creator: this.organisation.name,
      description: this.organisation.shortDescription,
      image: this.organisation.image,
    })
  }
}
